import React, { useRef } from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import logo from "../../../images/logo-transparent.7a4badaf.png";
import { connect } from "react-redux";

import moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "left",
      color: theme.palette.text.secondary,
    },
    button: {
      display: "block",
      marginTop: theme.spacing(2),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    select: {
      margin: "0 0 0 -8px",
      minWidth: "145px",
      width: "100%",
      height: "40px",
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
  })
);
interface Props {}
const InvoicePdf: React.FC<Props> = ({}) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  let componentRef = useRef<any>(null);
  const data = location.state;
  const price_in_words = (price: any) => {
    let sglDigit = [
        "Zero",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ],
      dblDigit = [
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ],
      tensPlace = [
        "",
        "Ten",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ],
      handle_tens = function (dgt: number, prevDgt: number) {
        return 0 === dgt
          ? ""
          : " " + (1 === dgt ? dblDigit[prevDgt] : tensPlace[dgt]);
      },
      handle_utlc = function (dgt: number, nxtDgt: number, denom: string) {
        return (
          (0 != dgt && 1 != nxtDgt ? " " + sglDigit[dgt] : "") +
          (0 != nxtDgt || dgt > 0 ? " " + denom : "")
        );
      };

    let str = "";
    let digitIdx: number = 0;
    let digit: number;
    let nxtDigit: number = 0;
    let words = [];
    if (((price += ""), isNaN(parseInt(price)))) str = "";
    else if (parseInt(price) > 0 && price.length <= 10) {
      for (digitIdx = price.length - 1; digitIdx >= 0; digitIdx--)
        switch (
          ((digit = price[digitIdx] - 0),
          (nxtDigit = digitIdx > 0 ? price[digitIdx - 1] - 0 : 0),
          price.length - digitIdx - 1)
        ) {
          case 0:
            words.push(handle_utlc(digit, nxtDigit, ""));
            break;
          case 1:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 2:
            words.push(
              0 != digit
                ? " " +
                    sglDigit[digit] +
                    " Hundred" +
                    (0 != price[digitIdx + 1] && 0 != price[digitIdx + 2]
                      ? " and"
                      : "")
                : ""
            );
            break;
          case 3:
            words.push(handle_utlc(digit, nxtDigit, "Thousand"));
            break;
          case 4:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 5:
            words.push(handle_utlc(digit, nxtDigit, "Lakh"));
            break;
          case 6:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 7:
            words.push(handle_utlc(digit, nxtDigit, "Crore"));
            break;
          case 8:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 9:
            words.push(
              0 != digit
                ? " " +
                    sglDigit[digit] +
                    " Hundred" +
                    (0 != price[digitIdx + 1] || 0 != price[digitIdx + 2]
                      ? " and"
                      : " Crore")
                : ""
            );
        }
      str = words.reverse().join("");
    } else str = "";
    return str;
  };
  const handleBack = () => {
    history.push(`/dashboard/gnadmin/cc_invoice`);
  };
  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    return <button>Print Receipt</button>;
  }, []);
  return (
    <div className={classes.root} style={{ marginTop: "50px" }}>
      <button
        style={{
          width: "120px",
          borderRadius: "5%",
          backgroundColor: "#ef5350",
          color: "white",
        }}
        onClick={handleBack}
      >
        {"<< Go Back"}
      </button>
      <ReactToPrint
        content={reactToPrintContent}
        trigger={reactToPrintTrigger}
      />
      <div ref={componentRef} style={{ margin: "50px" }}>
        <Grid
          container
          style={{
            border: "solid",
            borderColor: "black",
            borderWidth: "2px",
          }}
        >
          <Grid item xs={12} style={{ borderBottom: "ridge" }}>
            <Grid container>
              <Grid
                item
                xs={3}
                style={{
                  borderRight: "ridge",
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                {<img src={logo} alt="image" style={{ width: 200 }} />}
              </Grid>
              <Grid
                item
                xs={6}
                style={{ borderRight: "ridge", padding: "0 0 0 5px" }}
              >
                <Typography
                  variant="h6"
                  component="h1"
                  //align="center"
                  style={{ /*padding: "20px 0 0 0",*/ fontWeight: "bold" }}
                >
                  Redcliffe Labs
                </Typography>
                <Typography
                  style={
                    {
                      /*,whiteSpace: "pre"*/
                    }
                  }
                  variant="body2"
                >
                  H-55 3rd Floor
                  <br />
                  sector 63 Noida
                  <br />
                  Uttar Pradesh 201309 , IN
                </Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h4"
                  component="h1"
                  align="center"
                  style={{ fontWeight: "bold" }}
                >
                  Invoice
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ borderBottom: "ridge" }}>
            <Grid container>
              <Grid item xs={6} style={{ borderRight: "ridge" }}>
                <Grid container>
                  <Grid item xs={5} style={{ padding: "0 0 0 5px" }}>
                    <Typography
                      variant="subtitle2"
                      //style={{ /*padding: "20px 0 0 0",*/ fontWeight: "bold" }}
                    >
                      Invoice No.
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      //style={{ /*padding: "20px 0 0 0",*/ fontWeight: "bold" }}
                    >
                      Invoice Date
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography
                      variant="subtitle2"
                      align="right"
                      //style={{ /*padding: "20px 0 0 0",*/ fontWeight: "bold" }}
                    >
                      :
                    </Typography>

                    <Typography
                      variant="subtitle2"
                      align="right"
                      //style={{ /*padding: "20px 0 0 0",*/ fontWeight: "bold" }}
                    >
                      :
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      align="right"
                      //style={{ /*padding: "20px 0 0 0",*/ fontWeight: "bold" }}
                    >
                      :
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography
                      variant="subtitle2"
                      align="left"
                      //style={{ /*padding: "20px 0 0 0",*/ fontWeight: "bold" }}
                    >
                      {data?.invoice_no}
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      align="left"
                      //style={{ /*padding: "20px 0 0 0",*/ fontWeight: "bold" }}
                    >
                      {moment(data?.created_at).format("DD-MM-YYYY, h:mm A")}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} style={{}}>
                <Grid container>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={6}></Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={6} style={{ backgroundColor: "#b3b3b3" }}>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  Bill To
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ backgroundColor: "#b3b3b3" }}>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  Ship To
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ borderBottom: "ridge" }}>
            <Grid container>
              <Grid
                item
                xs={6}
                style={{ borderRight: "ridge", padding: "0 0 0 5px" }}
              >
                <Typography
                  variant="body1"
                  //style={{fontWeight:"bold"}}
                >
                  C/o {data?.center}
                  <br />
                  {data.centre_address?.area +
                    ", " +
                    data.centre_address?.city +
                    ", " +
                    data.centre_address?.state +
                    ", Pincode: " +
                    data.centre_address?.pincode}
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ padding: "0 0 0 5px" }}>
                <Typography
                  variant="body1"
                  //style={{fontWeight:"bold"}}
                >
                  C/o {data?.center}
                  <br />
                  {data.centre_address?.area +
                    ", " +
                    data.centre_address?.city +
                    ", " +
                    data.centre_address?.state +
                    ", Pincode: " +
                    data.centre_address?.pincode}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ backgroundColor: "#b3b3b3" }}>
            <Grid container>
              <Grid
                item
                xs={1}
                justifyContent="center"
                style={{
                  borderRight: "ridge",
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "bold" }}
                  align="center"
                >
                  #
                </Typography>
              </Grid>
              <Grid
                item
                xs={3}
                justifyContent="center"
                style={{
                  borderRight: "ridge",
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "bold" }}
                  align="center"
                >
                  Item Description
                </Typography>
              </Grid>

              <Grid
                item
                xs={2}
                justifyContent="center"
                style={{
                  borderRight: "ridge",
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "bold" }}
                  align="right"
                >
                  Total Bill
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                justifyContent="center"
                style={{
                  borderRight: "ridge",
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "bold" }}
                  align="right"
                >
                  Prev. Balance
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                justifyContent="center"
                style={{
                  borderRight: "ridge",
                  display: "grid",
                  alignItems: "end",
                }}
              >
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "bold" }}
                  align="center"
                >
                  RCL Share Amount
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                justifyContent="flex-end"
                style={{ display: "flex", alignItems: "flex-end" }}
              >
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "bold" }}
                  align="right"
                >
                  Amt. to Pay&nbsp;&nbsp;&nbsp;&nbsp;
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ borderBottom: "ridge" }}>
            <Grid container>
              <Grid
                item
                xs={1}
                style={{ borderRight: "ridge" }}
                alignItems="baseline"
                justifyContent="center"
              >
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "-moz-initial" }}
                  align="center"
                >
                  1.
                </Typography>
              </Grid>
              <Grid item xs={3} style={{ borderRight: "ridge" }}>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "-moz-initial" }}
                  align="center"
                  display="inline"
                >
                  Billing From:
                </Typography>

                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "bold" }}
                  align="left"
                  display="inline"
                >
                  &nbsp;{data?.start_date}
                </Typography>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "-moz-initial" }}
                  align="center"
                  display="inline"
                >
                  &nbsp;To:
                </Typography>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "bold" }}
                  align="left"
                  display="inline"
                >
                  &nbsp;{data?.end_date}
                </Typography>
              </Grid>

              <Grid item xs={2} style={{ borderRight: "ridge" }}>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "-moz-initial" }}
                  align="right"
                >
                  {Math.ceil(data?.total_billed_amount)}
                </Typography>
              </Grid>
              <Grid item xs={2} style={{ borderRight: "ridge" }}>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "-moz-initial" }}
                  align="right"
                ></Typography>
              </Grid>
              <Grid item xs={2} style={{ borderRight: "ridge" }}>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "-moz-initial" }}
                  align="right"
                >
                  {Math.ceil(data?.rcl_share_amount)}
                </Typography>
              </Grid>
              <Grid item xs={2} style={{}}>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "-moz-initial" }}
                  align="right"
                >
                  {Math.ceil(data?.rcl_share_amount)}&nbsp;/-
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid
                item
                xs={8}
                justifyContent="flex-start"
                style={{ padding: "0 0 0 5px" }}
              >
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "-moz-initial" }}
                  //align="center"
                >
                  Total in Words (INR):
                </Typography>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: "bold", fontStyle: "italic" }}
                  //align="center"
                >
                  {/*numWords(47200)*/}
                  {price_in_words(Math.ceil(data?.rcl_share_amount))} Only
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ padding: "0 0 0 5px" }}>
            <Typography
              variant="subtitle2"
              style={{ fontWeight: "bold" }}
              //align="center"
            >
              Payment Details:
            </Typography>

            <Typography
              variant="body1"
              style={{ fontWeight: "-moz-initial" }}
              //align="center"
              display="inline"
            >
              1.Cheque: In favour of &nbsp;
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: "bold" }}
              //align="center"
              display="inline"
            >
              REDCLIFFE LIFETECH PRIVATE LIMITED
            </Typography>
            <br />
            <Typography
              variant="body1"
              style={{ fontWeight: "-moz-initial" }}
              //align="center"
              display="inline"
            >
              2.Bank Details for &nbsp;
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: "bold" }}
              //align="center"
              display="inline"
            >
              NEFT/RTGS
            </Typography>
            <br />

            <Typography
              variant="body1"
              style={{ fontWeight: "-moz-initial" }}
              //align="center"
            >
              &nbsp;&nbsp;&nbsp;&nbsp;Bank:&nbsp;HDFC Bank
            </Typography>
            <Typography variant="body1">
              &nbsp;&nbsp;&nbsp;&nbsp;Branch:&nbsp;NOIDA
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: "-moz-initial" }}
              //align="center"
            >
              &nbsp;&nbsp;&nbsp;&nbsp;Address:&nbsp;HDFC BANK LTD,
            </Typography>

            <Typography
              variant="body1"
              style={{ fontWeight: "-moz-initial" }}
              //align="center"
              //display="inline"
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;H1A/12
              SECTOR-63,
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: "-moz-initial" }}
              //align="center"
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;GAUTAM
              BUDH NAGAR, NOIDA-201306,
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: "-moz-initial" }}
              //align="center"
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;UTTAR
              PARDESH
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: "-moz-initial" }}
              //align="center"
            >
              &nbsp;&nbsp;&nbsp;&nbsp;Account No:&nbsp;50200057800880
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: "-moz-initial" }}
              //align="center"
            >
              &nbsp;&nbsp;&nbsp;&nbsp;IFSC:&nbsp;HDFC0000975
            </Typography>
            <br />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps, {})(InvoicePdf);
